<template>

    <v-icon v-if="(offerPlatforms & PLATFORMS.android) > 0" class="action-item">
        <android-icon></android-icon>
    </v-icon>
    <v-icon v-if="(offerPlatforms & PLATFORMS.ipad) > 0" class="action-item">
        <i-pad-icon></i-pad-icon>
    </v-icon>
    <v-icon v-if="(offerPlatforms & PLATFORMS.iphone) > 0" class="action-item">
        <i-phone-icon></i-phone-icon>
    </v-icon>
    <v-icon v-if="(offerPlatforms & PLATFORMS.desktop) > 0" class="action-item">
        <windows-icon></windows-icon>
    </v-icon>

</template>



<script>

import iPadIcon from "@/icons/iPad.vue";
import iPhoneIcon from "@/icons/iPhone.vue";
import WindowsIcon from "@/icons/WindowsGrey.vue";
import AndroidIcon from "@/icons/AndroidGrey.vue";
import { PLATFORMS } from "@/constants/Platforms";

export default {
    name: 'PlatformIcons',
    components: {
        iPadIcon,
        iPhoneIcon,
        WindowsIcon,
        AndroidIcon,
    },
    props: {
        offerPlatforms: {
            type: Number,
            default: 1,
        },
    },
    setup() {
        return {
            PLATFORMS,
        }
    },
}
</script>



<style scoped lang="scss">
.action-item {
    margin: 2px;
    width: 15px;
    height: 24px;
}
</style>
